import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#4286f4",
    },
    secondary: {
      main: "#679ef6",
    },
    error: {
      main: "#f86c6b",
    },
    warning: {
      main: "#fcca72",
    },
    info: {
      main: "#63c2de",
    },
    success: {
      main: "#4dbd74",
    },
    white: {
      main: "#fff",
    },
    gray: {
      main: "#73818f",
      light: "rgb(200, 206, 211)",
    },
    background: {
      default: "rgb(250, 250, 250)",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        a: { textDecoration: "none" },
        ".beamer_defaultBeamerSelector": { display: "none" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        // Consistent, modern card treatment across the app: softer rounding and
        // a subtle shadow on elevation-1 surfaces (the dashboard / table cards).
        // Menus & dialogs sit at higher elevations, so they're unaffected.
        rounded: { borderRadius: 12 },
        elevation1: {
          boxShadow:
            "0 1px 3px rgba(16, 24, 40, 0.06), 0 1px 2px rgba(16, 24, 40, 0.04)",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          ".MuiDataGrid-overlayWrapper": {
            height: "auto !important",
          },
          ".MuiDataGrid-overlayWrapperInner": {
            height: "auto !important",
          },
        },
      },
    },
  },
});

export default theme;
